import React from 'react';
import { Trash2, KeyRound, ShieldCheck } from 'lucide-react';
import { ROLE_LABELS } from '../adminAccessMatrix';

const Pill = ({ children, tone }) => {
  const tones = {
    red: 'bg-red-500/15 text-red-300 border-red-500/30',
    amber: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
    green: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
    neutral: 'bg-slate-800 text-slate-200 border-slate-700',
  };
  return (
    <span className={`text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded border ${tones[tone] || tones.neutral}`}>
      {children}
    </span>
  );
};

/**
 * Single row of the Admin Team table. Pure presentational — parent owns
 * loading state, reset/revoke handlers, and the formatted last-login string.
 */
export function StaffTableRow({ staff, fmtTime, onReset, onRevoke }) {
  const s = staff;
  return (
    <tr className="hover:bg-slate-800/30" data-testid={`team-row-${s.id}`}>
      <td className="px-4 py-3 text-white font-medium flex items-center gap-2">
        <ShieldCheck className="w-4 h-4 text-amber-400" /> {s.name}
      </td>
      <td className="px-4 py-3 text-slate-300">{s.email}</td>
      <td className="px-4 py-3">
        <Pill>{ROLE_LABELS[s.role] || s.role}</Pill>
      </td>
      <td className="px-4 py-3">
        {s.status === 'revoked' ? (
          <Pill tone="red">revoked</Pill>
        ) : s.must_change_password ? (
          <Pill tone="amber">must change pw</Pill>
        ) : (
          <Pill tone="green">active</Pill>
        )}
      </td>
      <td className="px-4 py-3 text-xs text-slate-400 font-mono">{fmtTime(s.last_admin_login_at)}</td>
      <td className="px-2 py-3">
        <div className="flex justify-end gap-1">
          {s.status !== 'revoked' && (
            <>
              <button
                onClick={() => onReset(s)}
                data-testid={`team-reset-${s.id}`}
                title="Reset password"
                className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded bg-amber-500/15 border border-amber-500/30 text-amber-300 hover:bg-amber-500/25"
              >
                <KeyRound className="w-3 h-3" /> Reset
              </button>
              <button
                onClick={() => onRevoke(s)}
                data-testid={`team-revoke-${s.id}`}
                title="Revoke access"
                className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded bg-red-500/15 border border-red-500/30 text-red-300 hover:bg-red-500/25"
              >
                <Trash2 className="w-3 h-3" /> Revoke
              </button>
            </>
          )}
        </div>
      </td>
    </tr>
  );
}

export default StaffTableRow;
